<!-- Se renderiza solo si hay una fase activa (progreso < 100). El header y el grid se adaptan al
     `phase.layout` (vertical = Fase 1 · horizontal = Fase 2), data-driven sin ramas por phase_id. -->
<section
    *ngIf="activePhase$ | async as phase"
    class="onboarding"
    [class.onboarding--large]="phase.order === 1"
    [class.onboarding--horizontal]="phase.layout === 'horizontal'"
    [class.theme-green]="phase.theme === 'green'"
>
    <!-- ============ HEADER VERTICAL (Fase 1) ============ -->
    <header class="onboarding__header" *ngIf="phase.layout === 'vertical'">
        <fina-onboarding-progress-ring class="onboarding__ring" [percent]="phase.progress.overall" [done]="phase.tasks_done" [total]="phase.tasks_total"> </fina-onboarding-progress-ring>

        <div class="onboarding__heading">
            <div class="onboarding__title-row">
                <h2 class="onboarding__title">{{ phase.title }}</h2>
                <span class="onboarding__time-left">
                    <fa-icon [icon]="['fas', 'clock']" class="onboarding__time-left-icon"></fa-icon>
                    {{ phase.time_left_label }}
                </span>
            </div>
            <p class="onboarding__subtitle">{{ phase.subtitle }}</p>
        </div>

        <button type="button" class="onboarding__cta" (click)="openPhaseDetails()">Ver detalles</button>
    </header>

    <!-- ============ HEADER HORIZONTAL (Fase 2) ============ -->
    <header class="onboarding__header onboarding__header--h" *ngIf="phase.layout === 'horizontal'">
        <fina-onboarding-progress-ring class="onboarding__ring" [percent]="phase.progress.overall" [done]="phase.tasks_done" [total]="phase.tasks_total" [compact]="true">
        </fina-onboarding-progress-ring>

        <div class="onboarding__heading">
            <span class="onboarding__eyebrow">FASE {{ phase.order }} · {{ phase.timeframe_label }}</span>
            <h2 class="onboarding__title">{{ phase.title }}</h2>
            <span class="onboarding__counter">{{ phase.tasks_done }} de {{ phase.tasks_total }} {{ phase.counter_label || 'tareas de la fase' }}</span>
        </div>

        <button type="button" class="onboarding__detail" (click)="openPhaseDetails()">
            Ver detalles
            <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
        </button>
        <button type="button" class="onboarding__collapse" (click)="toggleCollapsed()" [attr.aria-label]="collapsed ? 'Expandir' : 'Colapsar'">
            <fa-icon [icon]="['fas', collapsed ? 'chevron-down' : 'chevron-up']"></fa-icon>
        </button>
    </header>

    <!-- ============ GRID DE TAREAS ============ -->
    <ul class="onboarding__grid" role="list" *ngIf="!collapsed">
        <ng-container *ngIf="visibleTasks(phase) as tasks">
            <li class="onboarding__grid-item" *ngFor="let task of tasks; let i = index">
                <fina-onboarding-task-card
                    [task]="task"
                    [variant]="resolveVariant(task, i === nextIndex(tasks))"
                    [large]="phase.order === 1"
                    [layout]="phase.layout"
                    [theme]="phase.theme || 'purple'"
                    (cardClick)="onTaskClick($event)"
                >
                </fina-onboarding-task-card>
            </li>
        </ng-container>
    </ul>
</section>
